module.exports = __webpack_public_path__ + "img/vestavena-skrin.edd5cb64.svg";